/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function isSelected(_ref) {
  var id = _ref.id,
    value = _ref.value;
  if (Array.isArray(value)) {
    return value.indexOf(id) !== -1;
  }
  return id === value;
}
var _default = isSelected;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/isSelected.js
// module id = 243
// module chunks = 0